/*eslint eqeqeq: "off"*/
export function getRandonIconBallColor(){
    // var colors=["1DA1F2","F45D22","17BF63","FFAD1F","8899A6","794BC4","E0245E"];
    // var randomColor = colors[Math.floor(Math.random() * colors.length)];
    return "8899A6";
}